import React from 'react';
import {
  Table,
  Tooltip,
  Select,
  Button,
  Checkbox,
  InputNumber,
  AutoComplete,
  notification,
  Row,
  Col,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import Loading from '../common/Loading';
import _ from 'lodash';
import { graphql, compose } from 'react-apollo';

import DrawerPosnet from '../admGeneral/ventaSellos/DrawerPosnet';
import DrawerMercadoPago from '../admGeneral/ventaSellos/DrawerMercadoPago';

import getTiposSellos from '../../graphql/querys/ventas/getTipoSellos.graphql';

import agregarDetalleVenta from '../../graphql/mutations/local/agregarDetalleVenta.graphql';
import agregarDatosPosnet from '../../graphql/mutations/local/agregarDatosPosnet.graphql';
import agregarDatosMP from '../../graphql/mutations/local/agregarDatosMP.graphql';
import agregarDatosRecibo from '../../graphql/mutations/local/agregarDatosRecibo.graphql';
import resetDatosVenta from '../../graphql/mutations/local/resetDatosVenta.graphql';
import aumentarCodigoOperacion from '../../graphql/mutations/organismos/aumentarCodigoOperacion.graphql';
import getEnvironment from '../../graphql/querys/common/getEnvironment.graphql';
import getUsuario from '../../graphql/querys/auth/getUsuario.graphql';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsDetalle from '../../actions/detalles';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@compose(
  graphql(getTiposSellos, {
    options: props => ({
      variables: {
        tramite: props.tramite ? props.tramite : '', //al llamarlo con '' trae todos los sellos
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(agregarDetalleVenta, {
    name: 'agregarDetalleVenta',
  }),
  graphql(agregarDatosPosnet, {
    name: 'agregarDatosPosnet',
  }),
  graphql(agregarDatosMP, {
    name: 'agregarDatosMP',
  }),
  graphql(agregarDatosRecibo, {
    name: 'agregarDatosRecibo',
  }),
  graphql(resetDatosVenta, {
    name: 'resetDatosVenta',
  }),
  graphql(aumentarCodigoOperacion, {
    name: 'aumentarCodigoOperacion',
  }),
  graphql(getEnvironment, {
    name: 'getEnvironment',
  }),
  graphql(getUsuario, {
    name: 'usuario',
  })
)
class FormVentaSello extends React.Component {
  constructor(props) {
    super(props);

    // let listaTiposSellos = this.props.data.getTiposSellos;
    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      listaTiposSellos: this.props.data.getTiposSellos
        ? this.props.data.getTiposSellos
        : [],
      itemsVenta: [],
      itemTipoSeleccionado: '',
      cantTipoSeleccionada: '',
      drawerPosnetVisible: false,
      drawerMPVisible: false,
      codigoOperacion: null,
      enviarPorEmail: false,
      descargarRecibo: false,
      dataSource: [],
      email: '',
      agregada: false,
    };

    this.agregarItemVenta = this.agregarItemVenta.bind(this);
    this.devolverNombre = this.devolverNombre.bind(this);
    this.eliminarItem = this.eliminarItem.bind(this);
    this.calcularMontoTotal = this.calcularMontoTotal.bind(this);
  }

  async componentDidMount() {
    await this.props.resetDatosVenta();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log("Voy a recibir nuevas props", nextProps);
    if (!this.props.data.getTiposSellos && nextProps.data.getTiposSellos) {
      this.setState(
        {
          ...this.state,
          listaTiposSellos: nextProps.data.getTiposSellos,
          itemTipoSeleccionado:
            nextProps.data.getTiposSellos.length === 1
              ? nextProps.data.getTiposSellos[0]._id
              : '',
          cantTipoSeleccionada: 1,
        },
        function() {
          // console.log("Datos actualizados!")
        }
      );
    }
  }

  calcularMontoTotal() {
    let montoFinal = 0;

    let yo = this;
    _.each(this.state.itemsVenta, function(item) {
      var tipoSelloItem = _.find(yo.state.listaTiposSellos, function(
        tipoSello
      ) {
        return item.idTipo_Sello === tipoSello._id;
      });

      if (tipoSelloItem) {
        montoFinal = montoFinal + tipoSelloItem.valor * item.cantidad;
      }
    });
    return montoFinal;
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        this.props.onSubmit(values);
      }
    });
  };

  onFinalizar = (numeroTicket, codigoOperacion) => {
    this.props
      .agregarDatosPosnet({
        variables: {
          datosPosnet: {
            numeroTicket,
            codigoOperacion: codigoOperacion + '',
          },
        },
      })
      .then(res => {
        // console.log('RECIBO: ', res);
        if (res.errors) {
          console.log('ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET');
          notification.error({
            message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET',
          });
        } else {
          this.props.onFinalizar(
            this.state.itemsVenta,
            { numeroTicket, codigoOperacion },
            {
              enviarPorEmail: this.state.enviarPorEmail,
              descargarRecibo: this.state.descargarRecibo,
              email: this.state.email,
            }
          );
        }
      })
      .catch(err => {
        console.log('ERROR AL INSERTAR EN LOCAL LOS DATOS DEL POSNET: ', err);
        notification.error({
          message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET',
        });
      });
  };

  onFinalizarSinStock = (numeroTicket, codigoOperacion) => {
    this.props
      .agregarDatosPosnet({
        variables: {
          datosPosnet: {
            numeroTicket,
            codigoOperacion: codigoOperacion + '',
          },
        },
      })
      .then(res => {
        // console.log('RECIBO: ', res);
        if (res.errors) {
          console.log('ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET');
          notification.error({
            message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET',
          });
        } else {
          this.props
            .agregarDatosRecibo({
              variables: {
                datosRecibo: {
                  email: this.state.email,
                  enviarPorEmail: this.state.enviarPorEmail,
                  descargarRecibo: this.state.descargarRecibo,
                },
              },
            })
            .then(respuesta => {
              if (respuesta.errors) {
                console.log(
                  'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO'
                );
                notification.error({
                  message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
                });
              } else {
                this.props.crearVentaCompleta(
                  this.state.itemsVenta,
                  { numeroTicket, codigoOperacion },
                  {
                    enviarPorEmail: this.state.enviarPorEmail,
                    descargarRecibo: this.state.descargarRecibo,
                    email: this.state.email,
                  }
                );
              }
            })
            .catch(error => {
              console.log(
                'ERROR AL INSERTAR EN LOCAL LOS DATOS DEL RECIBO: ',
                error
              );
              notification.error({
                message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
              });
            });
        }
      })
      .catch(err => {
        console.log('ERROR AL INSERTAR EN LOCAL LOS DATOS DEL POSNET: ', err);
        notification.error({
          message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET',
        });
      });
  };

  onFinalizarMP = numeroComprobante => {
    this.props
      .agregarDatosMP({
        variables: {
          datosMP: {
            numeroComprobante,
          },
        },
      })
      .then(res => {
        // console.log('RECIBO ====>', res);
        if (res.errors) {
          console.log('ERROR EN LA INCORPORACION DE LOS DATOS DE MERCADO PAGO');
          notification.error({
            message: 'ERROR EN LA INCORPORACION DE LOS DATOS DE MERCADO PAGO',
          });
        } else {
          this.props
            .agregarDatosRecibo({
              variables: {
                datosRecibo: {
                  email: this.state.email,
                  enviarPorEmail: this.state.enviarPorEmail,
                  descargarRecibo: this.state.descargarRecibo,
                },
              },
            })
            .then(respuesta => {
              if (respuesta.errors) {
                console.error(
                  'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
                  respuesta.errors
                );
                notification.error({
                  message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
                });
              } else {
                this.props.crearVentaMercadoPago(
                  this.state.itemsVenta,
                  { numeroComprobante },
                  {
                    enviarPorEmail: this.state.enviarPorEmail,
                    descargarRecibo: this.state.descargarRecibo,
                    email: this.state.email,
                  }
                );
              }
            })
            .catch(error => {
              console.error(
                'ERROR AL INSERTAR EN LOCAL LOS DATOS DEL RECIBO: ',
                error
              );
              notification.error({
                message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
              });
            });
        }
      })
      .catch(err => {
        console.log('ERROR AL INSERTAR EN LOCAL LOS DATOS DEL POSNET: ', err);
        notification.error({
          message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL POSNET',
        });
      });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleChange = valor => {
    this.setState({
      ...this.state,
      itemTipoSeleccionado: valor,
      cantTipoSeleccionada: 1,
    });
  };

  cambioNumero = valor => {
    this.setState({
      ...this.state,
      cantTipoSeleccionada: valor,
    });
  };

  agregarItemVenta() {
    // console.log('STATE: ', this.state);

    let idTipo_Sello = this.state.itemTipoSeleccionado;
    let cantidad = this.state.cantTipoSeleccionada;
    if (cantidad > 0 && idTipo_Sello.length > 0) {
      let nuevoItemsVenta = this.state.itemsVenta;
      let nuevoDetalle = {
        idTipo_Sello,
        cantidad,
      };
      nuevoItemsVenta.push(nuevoDetalle);

      var output = _(nuevoItemsVenta)
        .groupBy('idTipo_Sello')
        .map((objs, key) => ({
          __typename: 'detalleItem',
          idTipo_Sello: key,
          cantidad: _.sumBy(objs, 'cantidad'),
        }))
        .value();

      this.props
        .agregarDetalleVenta({
          variables: { detalle_venta: output },
        })
        .then(res => {
          // console.log('RESPUESTA DEL AGREGAR ITEM VENTA: ', res);
          if (res.errors) {
            console.log('ERROR EN LA INCORPORACION DE UN DETALLE VENTA');
            notification.error({
              message: 'ERROR EN LA INCORPORACION DE UN DETALLE VENTA',
            });
          }
        })
        .catch(err => {
          if (err) {
            console.log('ERROR EN LA INCORPORACION DE UN DETALLE VENTA');
          }

          notification.error({
            message: 'Error al agregar un item de la venta',
            description: 'Se ha producido un error al realizar los cambios',
          });
        });

      this.setState({
        ...this.state,
        itemsVenta: output,
        itemTipoSeleccionado: '',
        cantTipoSeleccionada: '',
        agregada: true && !this.props.isTramiteAutorizacion,
      });
    }
  }

  eliminarItem(idTipo_Sello) {
    let nuevoItemsVenta = this.state.itemsVenta;

    _.remove(nuevoItemsVenta, {
      idTipo_Sello: idTipo_Sello,
    });

    this.props.actionsDetalle.setDetalles(nuevoItemsVenta);
    this.props
      .agregarDetalleVenta({
        variables: { detalle_venta: nuevoItemsVenta },
      })
      .then(res => {
        if (res.errors) {
          console.log('ERROR EN LA INCORPORACION DE UN DETALLE VENTA');
        }
      })
      .catch(err => {
        notification.error({
          message: 'Error al eliminar un item de la venta',
          description: 'Se ha producido un error al realizar los cambios',
        });
        console.error(err);
      });

    this.setState({
      ...this.state,
      itemsVenta: nuevoItemsVenta,
      agregada: false,
    });
  }

  crearOpciones(tipoSello) {
    return (
      <Option key={tipoSello._id} value={tipoSello._id}>
        {tipoSello.nombre}
      </Option>
    );
  }

  devolverNombre(idTipoSello) {
    let objeto = _.find(this.state.listaTiposSellos, { _id: idTipoSello });
    return objeto.nombre;
  }

  mostrarDrawerPosnet = () => {
    if (this.validarEmailField()) {
      // ^^primero validamos el campo email^^
      this.setState({
        drawerPosnetVisible: true,
      });
    }
  };

  ocultarDrawerPosnet = () => {
    this.setState({
      drawerPosnetVisible: false,
    });
  };

  mostrarDrawerMP = () => {
    if (this.validarEmailField()) {
      // ^^primero validamos el campo email^^
      this.setState({
        drawerMPVisible: true,
      });
    }
  };

  ocultarDrawerMP = () => {
    this.setState({
      drawerMPVisible: false,
    });
  };

  generarCodigoOperacion = () => {
    this.props
      .aumentarCodigoOperacion({
        variables: {
          idOrganismo: this.props.organismo._id,
        },
      })
      .then(respuesta => {
        // console.log('LA RESPUESTA RECIBIDA ES: ', respuesta);
        if (respuesta.data && respuesta.data.aumentarCodigoOperacion) {
          this.setState({
            codigoOperacion: respuesta.data.aumentarCodigoOperacion,
          });
        } else {
          console.log('NO EXISTE RESPUESTA');
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE SOLICITAR Y AUMENTAR EL CODIGO DE OPERACION DEL ORGANISMO'
        );
        console.log(err);
      });
  };

  handleChangeAutocomplete = value => {
    this.setState({
      dataSource:
        !value || value.indexOf('@') >= 0
          ? []
          : [
              `${value}@gmail.com`,
              `${value}@yahoo.com.ar`,
              `${value}@hotmail.com`,
              `${value}@jusneuquen.gov.ar`,
            ],
      email: value,
    });
  };

  validarEmailField = () => {
    // SI EL CAMPO ESTÁ VACÍO RETORNAMOS FALSE
    if (this.state.enviarPorEmail && this.state.email === '') {
      notification.error({
        message: 'Complete con un Email valido',
      });
      return false;
    }
    return true;
  };

  crearVentaCompleta = () => {
    if (this.validarEmailField()) {
      // ^^primero validamos el campo email^^
      this.props
        .agregarDatosRecibo({
          variables: {
            datosRecibo: {
              email: this.state.email,
              enviarPorEmail: this.state.enviarPorEmail,
              descargarRecibo: this.state.descargarRecibo,
            },
          },
        })
        .then(respuesta => {
          if (respuesta.errors) {
            console.log('ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO');
            notification.error({
              message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
            });
          } else {
            this.props.crearVentaCompleta(
              this.state.itemsVenta,
              { numeroTicket: null, codigoOperacion: null },
              {
                enviarPorEmail: this.state.enviarPorEmail,
                descargarRecibo: this.state.descargarRecibo,
                email: this.state.email,
              }
            );
          }
        })
        .catch(error => {
          console.log(
            'ERROR AL INSERTAR EN LOCAL LOS DATOS DEL RECIBO: ',
            error
          );
          notification.error({
            message: 'ERROR EN LA INCORPORACION DE LOS DATOS DEL RECIBO',
          });
        });
    }
  };

  render() {
    const { opcionRender } = this.props; //Esta variable sirve para saber si se debe renderizar como form o como input
    let opcionFormulario = opcionRender ? opcionRender : 1;
    let usuario = this.props.usuario.getUsuario;
    let environment = this.props.getEnvironment.getEnvironment;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTiposSellos = this.props.data.getTiposSellos;
    if (listaTiposSellos) {
      var opciones = _.map(listaTiposSellos, this.crearOpciones);
    } else {
      return <Loading />;
    }

    let columnasTabla = [];
    if (this.state.itemsVenta) {
      let yo = this;
      _.forEach(this.state.itemsVenta, function(value) {
        // console.log(value);
        if (value.idTipo_Sello.length > 0)
          columnasTabla.push({
            key: value.idTipo_Sello,
            nombre: yo.devolverNombre(value.idTipo_Sello),
            cantidad: value.cantidad,
          });
      });
    }

    return (
      <div>
        <h1 className="tituloForm">Venta de Tasas</h1>

        {opcionFormulario == 0 && (
          <Form onSubmit={this.handleSubmit} className="formularios">
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Buscar
              </Button>
            </FormItem>
          </Form>
        )}

        {opcionFormulario == 1 && (
          <div>
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Tipo Sello
                  <Tooltip title="Seleccione el tipo de tasa que desea vender">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <div>
                <Select
                  showSearch
                  style={{ width: 200, marginRight: 20 }}
                  /* eslint-disable-next-line react/no-string-refs */
                  ref="selectTipoSello"
                  placeholder="Seleccione un tipo de tasa"
                  value={this.state.itemTipoSeleccionado}
                  optionFilterProp="children"
                  onChange={this.handleChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  disabled={this.state.agregada}
                >
                  {opciones}
                </Select>
                Cantidad:
                <InputNumber
                  value={this.state.cantTipoSeleccionada}
                  onChange={this.cambioNumero}
                  /* eslint-disable-next-line react/no-string-refs */
                  ref="cantTipoSello"
                  style={{ marginLeft: 10, marginRight: 20 }}
                  min={1}
                  disabled={this.state.agregada}
                />
                <Button
                  type="primary"
                  onClick={this.agregarItemVenta}
                  disabled={this.state.agregada}
                >
                  Agregar
                </Button>
              </div>
            </FormItem>
          </div>
        )}

        {this.state.itemsVenta.length > 0 && (
          <div style={{ marginLeft: '5%' }}>
            <h1 style={{ textAlign: 'center', marginLeft: 55 }}>
              {' '}
              Detalle de la Venta{' '}
            </h1>
            <hr />
            <Table
              style={{ maxWidth: 650, marginLeft: '20%' }}
              dataSource={columnasTabla}
              pagination={false}
              columns={[
                { title: 'Nombre', dataIndex: 'nombre', key: 'nombre' },
                { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad' },
                {
                  title: 'Acciones',
                  key: 'acccion',
                  render: record => (
                    <span>
                      <Button
                        type="danger"
                        onClick={() => this.eliminarItem(record.key)}
                      >
                        Eliminar
                      </Button>
                    </span>
                  ),
                },
              ]}
            />
            <h3 style={{ textAlign: 'center' }}>
              Monto Total:
              {this.calcularMontoTotal().toLocaleString('es-AR', {
                style: 'currency',
                currency: 'ARS',
              })}
            </h3>

            <Row>
              <Col offset={4} span={6}>
                <Checkbox
                  onChange={e =>
                    this.setState({ enviarPorEmail: e.target.checked })
                  }
                >
                  Enviar recibo por email?
                </Checkbox>
              </Col>
              <Col span={6}>
                <AutoComplete
                  dataSource={this.state.dataSource}
                  style={{ width: 400 }}
                  onChange={this.handleChangeAutocomplete}
                  placeholder="Email"
                  disabled={!this.state.enviarPorEmail}
                />
              </Col>
            </Row>

            <Row>
              <Col offset={4} span={6}>
                <Checkbox
                  onChange={e =>
                    this.setState({ descargarRecibo: e.target.checked })
                  }
                >
                  Descargar recibo?
                </Checkbox>
              </Col>
            </Row>

            <FormItem {...tailFormItemLayout}>
              <Button
                type="primary"
                disabled={!this.props.crearVentaCompleta}
                onClick={this.crearVentaCompleta}
                style={{ marginLeft: '5%' }}
                loading={this.props.loading}
              >
                <Icons.DollarOutlined />
                Pagar en Efectivo
              </Button>

              <Button
                onClick={() => this.mostrarDrawerPosnet()}
                style={{ marginLeft: '5%' }}
                loading={this.props.loading}
              >
                <Icons.CreditCardOutlined />
                Pagar con Posnet
              </Button>

              <Button
                onClick={() => this.mostrarDrawerMP()}
                style={{ marginLeft: '5%' }}
                loading={this.props.loading}
              >
                <Icons.CreditCardOutlined />
                Pagar con Mercado Pago
              </Button>
            </FormItem>
          </div>
        )}

        <DrawerPosnet
          visible={this.state.drawerPosnetVisible}
          codigo={this.state.codigoOperacion}
          mostrarDrawer={() => this.mostrarDrawerPosnet()}
          ocultarDrawer={() => this.ocultarDrawerPosnet()}
          crearVentaCompleta={this.props.crearVentaCompleta}
          onFinalizarSinStock={this.onFinalizarSinStock}
          generarCodigoOperacion={this.generarCodigoOperacion}
          usuario={usuario}
          environment={environment}
        />

        <DrawerMercadoPago
          visible={this.state.drawerMPVisible}
          mostrarDrawer={() => this.mostrarDrawerMP()}
          ocultarDrawer={() => this.ocultarDrawerMP()}
          crearVentaCompleta={this.props.crearVentaMercadoPago}
          onFinalizarSinStock={this.onFinalizarMP}
          generarCodigoOperacion={this.generarCodigoOperacion}
          usuario={usuario}
          environment={environment}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsDetalle: bindActionCreators(actionsDetalle, dispatch),
});

function mapStateToProps(state) {
  // console.log("mapStateToPorps: ", state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(FormVentaSello));
